import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

const AlmKindRegistGridHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={classes.tableHeader}>No</TableCell>
      <TableCell className={classes.tableHeader}>{t('AlmKindRegistGridHeader.演算種別', '演算種別')}</TableCell>
      <TableCell className={classes.tableHeader}>{t('AlmKindRegistGridHeader.異常内容', '異常内容')}</TableCell>
      <TableCell className={classes.tableHeader}>{t('AlmKindRegistGridHeader.重故障メッセージ', '重故障メッセージ')}</TableCell>
      <TableCell className={classes.tableHeader}>{t('AlmKindRegistGridHeader.軽故障メッセージ', '軽故障メッセージ')}</TableCell>
    </TableRow>
  );
};

export default AlmKindRegistGridHeader;
